import React from 'react';
import { HomeType } from '../../../../domain/FilterTypes';
import { useFilterController } from '../../../../application/useFilterController';
import { HomeTypeBody } from './HomeTypeBody';

export const HomeTypeDrawerSection: React.FC = () => {
  const { filter, setHomeTypes } = useFilterController();

  const handleToggle = (homeType: HomeType) => {
    const currentTypes = filter.homeTypes || [];
    const newTypes = currentTypes.includes(homeType)
      ? currentTypes.filter(type => type !== homeType)
      : [ ...currentTypes, homeType ];

    setHomeTypes(newTypes);
  };

  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold mb-4">Home type</h3>
      <HomeTypeBody
        selectedTypes={filter.homeTypes || []}
        onToggle={handleToggle}
      />
    </div>
  );
};
